import React from "react";
import {
  Layout,
  Typography,
  Row,
  Col,
  Card,
  Breadcrumb,
  Divider,
  Carousel,
  Image,
} from "antd";
import { NavLink, useHistory } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import img from "../../assets/16.jpg";
import img1 from "../../assets/board-1.png";
import img2 from "../../assets/board-2.png";
import img3 from "../../assets/board-3.png";
import img4 from "../../assets/board-4.png";

import s from "./styles.module.css";
import { Fade } from "react-awesome-reveal";
import { SendButton } from "../../components/SendButton";

const { Header, Content } = Layout;
const { Title, Paragraph } = Typography;

export const BoardOfDirectorsPay = () => {
  const history = useHistory();

  const onReturn = () => {
    history.push("/");
  };
  return (
    <Layout>
      <Row
        style={{
          position: "absolute",
          maxWidth: "1440px",
          top: "80px",
          margin: "0 auto",
          padding: "0 20px",
          zIndex: 100,
          right: 0,
          left: 0,
        }}
      >
        <Col>
          <Title className={s["board-of-directors-pay-title"]}>
            Board of Directors Pay
          </Title>
          <Breadcrumb
            items={[
              {
                title: (
                  <NavLink to={"/"}>
                    <ArrowLeftOutlined style={{ marginRight: "5px" }} />
                    Back to main
                  </NavLink>
                ),
              },
            ]}
          />{" "}
        </Col>
      </Row>
      <Carousel effect={"fade"}>
        <div className={s["main-carusel-wrapper"]}>
          <img src={img} alt="Board" className="responsive-image" />
          <Content
            style={{ padding: "24px", maxWidth: "1440px", margin: "0 auto" }}
          >
            <Row className={s["main-carusel-row"]}>
              <Col xs={24} md={12} style={{ zIndex: 2 }}>
                <div className={s["main-carusel-title"]}>
                  Maximize the Impact of Your Board with Strategic Compensation
                </div>
                <Paragraph className={s["main-carusel-description"]}>
                  We understand attracting and retaining top talent on your
                  board is critical to your company’s long-term success. Our
                  specialized Board of Directors Pay consulting services ensure
                  that your compensation plans are competitive, transparent, and
                  aligned with the strategic vision of your business.
                </Paragraph>
              </Col>
            </Row>
          </Content>
        </div>
      </Carousel>
      <Divider />
      <Content
        style={{ padding: "24px", maxWidth: "1440px", margin: "0 auto" }}
      >
        <Fade cascade triggerOnce damping={0.1}>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Card className={s["board-of-directors-pay-card"]}>
                <Image src={img1} preview={false} />
                <Title level={3}>
                  Tailored Compensation Plans for Effective Leadership
                </Title>
                <Paragraph>
                  Your board is pivotal in steering the company, and their
                  compensation should reflect that responsibility. We work
                  closely with your team to design customized pay packages that
                  recognize the unique contributions of your board members.
                  Whether it’s cash retainers, stock options, or
                  performance-based incentives, we craft compensation solutions
                  that motivate and engage your directors.
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card className={s["board-of-directors-pay-card"]}>
                <Image src={img2} preview={false} />
                <Title level={3}>
                  Competitive Benchmarking for Attracting Top Talent
                </Title>
                <Paragraph>
                  In today’s competitive market, attracting board members
                  requires more than just competitive salaries. Our consultants
                  use data-driven benchmarking to analyze compensation trends
                  across your industry, ensuring that your board packages are
                  market-competitive and appealing to the most sought-after
                  directors. We help position your company as an attractive
                  destination for board leadership.
                </Paragraph>
              </Card>
            </Col>
          </Row>
          <Divider />
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Card className={s["board-of-directors-pay-card"]}>
                <Image src={img3} preview={false} />
                <Title level={3}>
                  Aligning Compensation with Governance Best Practices
                </Title>
                <Paragraph>
                  A well-compensated board is essential to good corporate
                  governance. Our experts align director pay with governance
                  best practices, ensuring that your compensation packages
                  promote long-term business stability and shareholder trust. By
                  linking pay to the company's strategic objectives, we
                  guarantee your board receives full incentivization to make
                  decisions that drive growth and success.
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card className={s["board-of-directors-pay-card"]}>
                <Image src={img4} preview={false} />
                <Title level={3}>Compliance and Shareholder Transparency</Title>
                <Paragraph>
                  Navigating the complexities of board compensation requires
                  expert regulation and knowledge of shareholder expectations.
                  We guide disclosure requirements, regulatory compliance, and
                  shareholder communications, ensuring your board pay is
                  transparent, fair, and fully compliant with all relevant
                  regulations.
                </Paragraph>
              </Card>
            </Col>
          </Row>
          <Divider />
          <Row justify="center" className={s["board-of-directors-pay-footer"]}>
            <Col>
              <Paragraph>
                Empower Your Board with Compensation That Inspires. Transform
                your board of directors into a high-performance team with a
                compensation strategy that drives results. Contact us today to
                learn how we can help you design the ideal pay structure for
                your board.
              </Paragraph>
              <SendButton
                type="primary"
                size="large"
                className={s["board-of-directors-pay-button"]}
              >
                Get in Touch
              </SendButton>
            </Col>
          </Row>
        </Fade>
      </Content>
    </Layout>
  );
};
